export enum TipoBaixaEnum {

  INTEGRACAO,
  MANUAL
}
